const EDUCATION_TEST_DETAIL_TABS = [
  { id: 'content', label: 'Содержание', icon: 'file' },
  { id: 'assignments', label: 'Назначения', icon: 'raising-hand' },
  { id: 'statistics', label: 'Статистика', icon: 'chart' },
  { id: 'reviews', label: 'Отзывы', icon: 'doc-tablet' },
];

const EDUCATION_TEST_DETAIL_ACTIONS = [
  { id: 'edit', labelKey: 'education.actions.edit', icon: 'pencil-simple' },
  { id: 'assign', labelKey: 'education.actions.assign', icon: 'user-plus' },
  { id: 'achievement', labelKey: 'education.actions.achievement', icon: 'trophy' },
  { id: 'add', labelKey: 'education.actions.add', icon: 'plus' },
  { id: 'download', labelKey: 'education.actions.download', icon: 'download' },
  { id: 'archive', labelKey: 'education.actions.archive', icon: 'archive-box', danger: true },
  { id: 'delete', labelKey: 'education.actions.delete', icon: 'trash', danger: true },
];

const EDUCATION_TEST_DETAIL_ASSIGNMENTS = {
  titleKey: 'education.assignments.title',
  assignButtonKey: 'education.assignments.assignButton',
  count: 14,
  assignees: [
    {
      id: 'waiter-evgenev-1',
      role: 'официант',
      name: 'Евгеньев Евгений',
      details: [
        { id: 'completed', icon: 'check', value: 'Завершено', column: 'left' },
        { id: 'completed-at', icon: 'calendar', value: '12.12.2012', column: 'left' },
        { id: 'viewed', icon: 'time', value: 'Просмотрено', column: 'right' },
        { id: 'deadline', icon: 'calendar-x', value: '11.12.2012', column: 'right', danger: true },
      ],
    },
    {
      id: 'waiter-evgenev-2',
      role: 'официант',
      name: 'Евгеньев Евгений',
      details: [
        { id: 'completed', icon: 'check', value: 'Завершено', column: 'left' },
        { id: 'completed-at', icon: 'calendar', value: '12.12.2012', column: 'left' },
        { id: 'viewed', icon: 'time', value: 'Просмотрено', column: 'right' },
        { id: 'deadline', icon: 'calendar-x', value: '11.12.2012', column: 'right', danger: true },
      ],
    },
    {
      id: 'waiter-evgenev-3',
      role: 'официант',
      name: 'Евгеньев Евгений',
      details: [
        { id: 'completed', icon: 'check', value: 'Завершено', column: 'left' },
        { id: 'completed-at', icon: 'calendar', value: '12.12.2012', column: 'left' },
        { id: 'viewed', icon: 'time', value: 'Просмотрено', column: 'right' },
        { id: 'deadline', icon: 'calendar-x', value: '11.12.2012', column: 'right', danger: true },
      ],
    },
    {
      id: 'waiter-evgenev-4',
      role: 'официант',
      name: 'Евгеньев Евгений',
      details: [
        { id: 'completed', icon: 'check', value: 'Завершено', column: 'left' },
        { id: 'completed-at', icon: 'calendar', value: '12.12.2012', column: 'left' },
        { id: 'viewed', icon: 'time', value: 'Просмотрено', column: 'right' },
        { id: 'deadline', icon: 'calendar-x', value: '11.12.2012', column: 'right', danger: true },
      ],
    },
  ],
};

const EDUCATION_TEST_DETAIL_STATISTICS = {
  titleKey: 'education.statistics.title',
  cards: [
    {
      id: 'assigned',
      titleKey: 'education.statistics.assigned',
      value: '14',
      icon: 'raising-hand',
    },
    {
      id: 'completed',
      titleKey: 'education.statistics.completed',
      value: '9',
      icon: 'chart',
    },
    {
      id: 'in-progress',
      titleKey: 'education.statistics.inProgress',
      value: '5',
      icon: 'hourglass-done',
    },
    {
      id: 'average-time',
      titleKey: 'education.statistics.averageTime',
      value: '15 минут',
      icon: 'average-time',
    },
  ],
};

const EDUCATION_TEST_DETAIL_REVIEWS = {
  titleKey: 'education.reviews.title',
  count: 2,
  items: [
    {
      id: 'review-evgenev-1',
      role: 'официант',
      name: 'Евгеньев Евгений',
      rating: '4.9',
      comment:
        'Регламент понятный, все шаги описаны коротко и без лишней воды. Особенно пригодился блок с последовательностью действий при эвакуации гостей.',
    },
    {
      id: 'review-evgenev-2',
      role: 'официант',
      name: 'Евгеньев Евгений',
      rating: '4.9',
      comment:
        'Материал легко пройти за один подход. После просмотра стало понятнее, кто отвечает за проверку зала и как быстро передать информацию менеджеру.',
    },
  ],
};

export const EDUCATION_TEST_KNOWLEDGE_LIBRARY_ITEMS = [
  {
    id: 'waiter-orders-course',
    name: 'Работа с заказами в Waiter',
    title: 'Работа с заказами в Waiter',
    description: 'Научит создавать, редактировать и закрывать заказ у стола в приложении qbeek.',
    accessLabel: 'Все роли',
    lessonCount: 4,
    quizCount: 1,
    gameCount: 1,
    category: 'Курс',
    status: 'Активный',
    views: 124,
    rating: '4.9',
    type: 'course',
    statusKey: 'active',
    details: {
      title: 'Приложение qbeek',
      description: 'Научит создавать, редактировать и закрывать заказ у стола в приложении qbeek.',
      accessLabel: 'Все роли',
      lessonCount: 4,
      date: '01.11.2025',
      author: 'Устинова Екатерина',
      duration: '45 минут',
      views: '124',
      activeTabId: 'content',
      tabs: EDUCATION_TEST_DETAIL_TABS,
      actions: EDUCATION_TEST_DETAIL_ACTIONS,
      assignments: EDUCATION_TEST_DETAIL_ASSIGNMENTS,
      statistics: EDUCATION_TEST_DETAIL_STATISTICS,
      reviews: EDUCATION_TEST_DETAIL_REVIEWS,
      lessons: [
        {
          id: 'waiter-auth',
          ordinal: 1,
          title: 'Авторизация',
          description: 'В данном уроке вы узнаете как скачать, получить доступы и авторизироваться в приложении qbeek.',
        },
        {
          id: 'waiter-menu',
          ordinal: 2,
          title: 'Основное меню',
          description: 'Расскажет о пунктах меню, быстрых переходах и как пройти первые шаги к первому созданию заказа.',
        },
        {
          id: 'waiter-create-order',
          ordinal: 3,
          title: 'Создание заказа',
          description: 'Научит создавать, редактировать и закрывать заказ у стола в приложении qbeek.',
        },
        {
          id: 'waiter-items',
          ordinal: 4,
          title: 'Работа с позициями',
          description: 'Научит как работать с позициями, оставлять комментарии и работать с весовыми позициями.',
        },
      ],
      sections: [
        {
          title: 'Содержание',
          files: [
            {
              id: 'waiter-auth-file',
              kind: 'урок',
              name: 'Авторизация',
              duration: '8 мин',
              meta: 'Старт приложения',
              icon: 'file',
              actions: ['view'],
            },
            {
              id: 'waiter-order-file',
              kind: 'урок',
              name: 'Создание заказа',
              duration: '12 мин',
              meta: 'Практика',
              icon: 'doc-tablet',
              actions: ['view'],
            },
          ],
        },
      ],
    },
  },
  {
    id: 'hot-dishes-course',
    name: 'Горячие блюда',
    title: 'Горячие блюда',
    positionCount: 12,
    isAgeRestricted: true,
    category: 'Курс',
    status: 'Черновик',
    views: 18,
    rating: '',
    type: 'course',
    statusKey: 'draft',
    details: {
      title: 'Горячие блюда',
      description: '',
      positionCount: 12,
      isAgeRestricted: true,
      date: '01.11.2025',
      author: 'Устинова Екатерина',
      duration: '20 минут',
      views: '18',
      activeTabId: 'content',
      tabs: EDUCATION_TEST_DETAIL_TABS,
      actions: EDUCATION_TEST_DETAIL_ACTIONS,
      assignments: EDUCATION_TEST_DETAIL_ASSIGNMENTS,
      statistics: EDUCATION_TEST_DETAIL_STATISTICS,
      reviews: EDUCATION_TEST_DETAIL_REVIEWS,
      sections: [
        {
          title: 'Содержание',
          files: [
            {
              id: 'hot-dishes-intro',
              kind: 'урок',
              name: 'Подача горячих блюд',
              duration: '4 мин',
              meta: '12 позиций',
              icon: 'file',
              actions: ['view'],
            },
          ],
        },
      ],
    },
  },
  {
    id: 'cold-dishes-course',
    name: 'Холодные блюда',
    title: 'Холодные блюда',
    positionCount: 10,
    category: 'Курс',
    status: 'Активный',
    views: 87,
    rating: '4.4',
    type: 'course',
    statusKey: 'active',
    details: {
      title: 'Холодные блюда',
      description: '',
      positionCount: 10,
      date: '03.11.2025',
      author: 'Устинова Екатерина',
      duration: '18 минут',
      views: '87',
      activeTabId: 'content',
      tabs: EDUCATION_TEST_DETAIL_TABS,
      actions: EDUCATION_TEST_DETAIL_ACTIONS,
      assignments: EDUCATION_TEST_DETAIL_ASSIGNMENTS,
      statistics: EDUCATION_TEST_DETAIL_STATISTICS,
      reviews: EDUCATION_TEST_DETAIL_REVIEWS,
      sections: [
        {
          title: 'Содержание',
          files: [
            {
              id: 'cold-dishes-intro',
              kind: 'урок',
              name: 'Подача холодных блюд',
              duration: '18 мин',
              meta: '10 позиций',
              icon: 'chart',
              actions: ['view'],
            },
          ],
        },
      ],
    },
  },
  {
    id: 'hot-snacks-course',
    name: 'Горячие закуски',
    title: 'Горячие закуски',
    positionCount: 4,
    category: 'Курс',
    status: 'Отключенный',
    views: 9,
    rating: '',
    type: 'course',
    statusKey: 'disabled',
    details: {
      title: 'Горячие закуски',
      description: '',
      positionCount: 4,
      date: '04.11.2025',
      author: 'Устинова Екатерина',
      duration: '12 минут',
      views: '9',
      activeTabId: 'content',
      tabs: EDUCATION_TEST_DETAIL_TABS,
      actions: EDUCATION_TEST_DETAIL_ACTIONS,
      assignments: EDUCATION_TEST_DETAIL_ASSIGNMENTS,
      statistics: EDUCATION_TEST_DETAIL_STATISTICS,
      reviews: EDUCATION_TEST_DETAIL_REVIEWS,
      sections: [
        {
          title: 'Содержание',
          files: [
            {
              id: 'hot-snacks-intro',
              kind: 'урок',
              name: 'Подача горячих закусок',
              duration: '12 мин',
              meta: '4 позиции',
              icon: 'file',
              actions: ['view'],
            },
          ],
        },
      ],
    },
  },
];
